import { render, staticRenderFns } from "./SelectCategories.vue?vue&type=template&id=29aa23cd&scoped=true&"
import script from "./SelectCategories.vue?vue&type=script&lang=js&"
export * from "./SelectCategories.vue?vue&type=script&lang=js&"
import style0 from "./SelectCategories.vue?vue&type=style&index=0&id=29aa23cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa23cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VCard,VChip,VChipGroup,VCol,VForm,VRow,VSkeletonLoader})
